export default Object.freeze({
  action: 'action',
  divider: 'divider',
  header: 'header',
})
